<div class="vendor-po-upload p-3" *ngIf="vendor">
	<h5 class="mb-3">Upload PO</h5>
	<p class="text-muted small">Upload a CSV or Excel file, map columns to item, quantity, and price, then build lines and create a purchase order for this vendor.</p>

	<div class="mb-3">
		<div class="d-flex align-items-center flex-wrap gap-2 mb-2">
			<button mat-stroked-button (click)="downloadPoUploadTemplate()">
				<mat-icon>file_download</mat-icon> Download template
			</button>
		</div>
		<ngx-dropzone class="vendor-upload-dropzone" [multiple]="true" [accept]="'.csv,.xlsx,.xls'" (change)="onDropzoneChange($event)" [disabled]="processing">
			<ngx-dropzone-label>DROP FILE HERE OR CLICK TO UPLOAD</ngx-dropzone-label>
			<ngx-dropzone-preview *ngFor="let f of files" [removable]="true" (removed)="onRemove(f)">
				<ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
			</ngx-dropzone-preview>
		</ngx-dropzone>
		<div *ngIf="processing" class="mt-2">
			<svg class="spinner" width="24" height="24" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
				<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
			</svg> Parsing…
		</div>
	</div>

	<div *ngIf="uploadReady && uploadedRawData.length" class="table-responsive">
		<table class="table table-sm table-striped">
			<thead>
				<tr>
					<th *ngFor="let h of uploadedHeaders" class="small">
						<mat-form-field appearance="outline" class="w-100" style="margin-bottom: -1.25em;">
							<mat-select [(value)]="columnMappings[h]" (selectionChange)="columnMappings[h] = $event.value">
								<mat-option *ngFor="let type of availableFieldTypes" [value]="type">{{ type }}</mat-option>
							</mat-select>
						</mat-form-field>
						<div class="small text-muted">{{ h }}</div>
					</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let row of uploadedRawData; let i = index" [class.table-primary]="i < 3">
					<td *ngFor="let h of uploadedHeaders">{{ row[h] }}</td>
				</tr>
			</tbody>
		</table>
		<div class="d-flex align-items-center mt-3 flex-wrap gap-2">
			<button mat-raised-button color="accent" (click)="buildLines()" [disabled]="!hasRequiredMappings()">
				Build lines
			</button>
			<button mat-stroked-button (click)="clearAll()">Clear</button>
		</div>

		<div *ngIf="builtLines.length" class="mt-4">
			<h6 class="mb-2">PO lines</h6>
			<div class="table-responsive">
				<table class="table table-sm table-bordered">
					<thead>
						<tr>
							<th>Item (stockid)</th>
							<th>Quantity</th>
							<th>Price</th>
							<th>Description</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let line of builtLines; let i = index">
							<td><input class="form-control form-control-sm" [(ngModel)]="line.stockid" placeholder="stockid" /></td>
							<td><input class="form-control form-control-sm" type="number" step="0.01" [(ngModel)]="line.quantity" placeholder="qty" /></td>
							<td><input class="form-control form-control-sm" type="number" step="0.01" [(ngModel)]="line.price" placeholder="price" /></td>
							<td><input class="form-control form-control-sm" [(ngModel)]="line.description" placeholder="description" /></td>
							<td><button mat-icon-button color="warn" (click)="removeLine(i)" matTooltip="Remove line"><mat-icon>delete</mat-icon></button></td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="d-flex align-items-center mt-2 flex-wrap gap-2">
				<button mat-stroked-button (click)="addLine()"><mat-icon>add</mat-icon> Add line</button>
				<button mat-raised-button color="primary" (click)="createPo()" [disabled]="creating">
					<ng-container *ngIf="!creating">Create PO</ng-container>
					<ng-container *ngIf="creating">Creating…</ng-container>
				</button>
				<span class="text-success" *ngIf="poSuccess">{{ poSuccess }}</span>
				<span class="text-danger" *ngIf="poError">{{ poError }}</span>
			</div>
		</div>
	</div>
</div>

<div *ngIf="!vendor" class="p-3 text-muted">Select a vendor to upload a PO.</div>
